import { startTransition, useActionState, useContext, useEffect, useOptimistic, useState, } from "react";
import { format, addMilliseconds } from "date-fns";

import axios from "axios";

// Dialog関連
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from '@mui/material';
import { Box, Grid, Paper, TextField, LinearProgress, CircularProgress, Pagination, Stack } from '@mui/material';
import { TableContainer, Table, TableHead, TableRow, TableBody, TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

import AppContext from "../contexts/AppContext";
import CookieContext from "../contexts/CookieContext";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#e9dfdf',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));


const List = () => {
  const { apiHost, AppButton } = useContext(AppContext);
  const basePath = 'list/';
  const { cookies } = useContext(CookieContext);

  const [error, setError] = useState();

  const interval = 5000;
  const [ip, setIp] = useState("");

  const [nowLoadingOpen, setNowLoadingOpen] = useState(false);
  const [elevation, setElevation] = useState('6');

  // 前回記録保持用
  const [lastRequestDateTime, setLastRequestDateTime] = useState("1999-12-31 23:59:59");
  const [lastResponseDateTime, setLastResponseDateTime] = useState("1999-12-31 23:59:59");

  const [responseTime, setResponseTime] = useState(0);

  // intervalAccessTime = interval + responseTimeで接続の度に更新
  const [intervalAccessTime, setIntervalAccessTime] = useState(interval);
  // nextAccessTimeは次回アクセスの参考表示用
  const [nextAccessTime, setNextAccessTime] = useState(
    format(addMilliseconds(Date.now(), interval), "HH:mm:ss")
  );

  // const [item, setItem] = useState({});
  // const [id, setId] = useState();
  const [listUuid, setListUuid] = useState();
  // const [roomUuid, setRoomUuid] = useState();
  const [name, setName] = useState();
  const [managementCd, setManagementCd] = useState()

  const [transactionFinishedDialogOpen, setTransactionFinishedDialogOpen] = useState(false);
  const handleTransactionFinishedDialogClose = () => {
    setTransactionFinishedDialogOpen(false);
  }
  // const [messageBoxTitle, setMessageBoxTitle] = useState('');
  // const [messageBoxMessage, setMessageBoxMessage] = useState('');


  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [messageBoxTitle, setMessageBoxTitle] = useState('');
  const [messageBoxMessage, setMessageBoxMessage] = useState('');

  const handleMessageBoxOpen = (title, message) => {
    setMessageBoxTitle(title);
    setMessageBoxMessage(message);
    setMessageBoxOpen(true);
  }
  const handleMessageBoxClose = () => {
    setMessageBoxOpen(false);
  }

  const [editDialogOpen, setEditDialogOpen] = useState(false);

  const handleEditDialogOpen = () => {
    setEditDialogOpen(true);
  }

  const handleEditDialogClose = (e) => {
    setEditDialogOpen(false);
    e.preventDefault();
  }

  const [lists, refreshLists, isPendingLists] = useActionState(
    async () => {
      try {
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        };

        const response = await fetch(apiHost + basePath, { headers });

        if (response.status === 200) {
          const data = await response.json();
          // setLists(data);
          return data
        }
        else if (response.status === 401) {
          setError('ログインしてください');
        }
        else {
          setError('エラー');
        }
      } catch (err) {
        console.log(err);
      }
    }, null
  )


  const [listlists, refreshListLists, isPendingListLists] = useActionState(
    async () => {
      // const optimistic = {
      //   uuid: listUuid,
      //   name: 'Now Loading...',
      // };

      // // 楽観的更新情報を表示
      // updateOptimisticListLists(optimistic);
 
      try {
        if (cookies.jwtAccess) {
          // jwtがある場合、headers（認証情報）有り
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': `JWT ${cookies.jwtAccess}`,
          }

          const response1 = await axios.get(`${apiHost}${basePath}${listUuid}/`, 
            {headers},
          )

          if (response1.status === 200) {
            setName(response1.data.name);
          } else if (response1.status === 401) {
            setError('ログインしてください');
          } else {
            setError('エラー');
          }

            // const response = await axios.get(`${apiHost}${basePath}${listUuid}/list/?list_uuid=db1896af-2d6f-4405-8ee0-4d1e290c0edf`, 
          // const response = await axios.get(`${apiHost}${basePath}?list_uuid=${listUuid}`, 
          const response2 = await axios.get(`${apiHost}${basePath}list/${listUuid}/`, 
          // const response = await axios.get(`${apiHost}${basePath}list/?list_uuid=${listUuid}`, 
          {headers},
          )

          if (response2.status === 200) {
            // setName(response.data.name);

            // 更新した名前を返す
            return response2.data

          } else if (response2.status === 401) {
            setError('ログインしてください');
          } else {
            setError('エラー');
          }
        } else {
          setError('認証エラー');
        }
      } catch (err) {
        setError('通信エラー');
      } finally {
      }
    }, ""
  );

  const [updatedPost, submitActionPost, isPendingPost] = useActionState(
    async (previousPost, formData) => {
      const name = formData.get('name');

      const optimistic = {
        list_uuid: listUuid,
        name: name + '（更新中）',
        // room_uuid: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
      };

      // 楽観的更新情報を表示
      updateOptimisticPost(optimistic);

      // 入力欄をクリアしてフォーカスを当てる 
      document.getElementById('name').value = "";
      document.getElementById('name')?.focus();
  
      try {
        if (cookies.jwtAccess) {
          // jwtがある場合、headers（認証情報）有り
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': `JWT ${cookies.jwtAccess}`,
          }

          const response = await axios.post(`${apiHost}${basePath}`, 
              {
              name: formData.get('name'),
            },
            {headers},
          )

          if (response.status === 201) {
            setTransactionFinishedDialogOpen(true);
            // 更新した名前を返す
            return response.data
          } else if (response.status === 401) {
            setError('ログインしてください');
          } else {
            setError('エラー');
          }
        } else {
          setError('認証エラー');
        }
      } catch (err) {
        // handleMessageBoxOpen('タイトル', 'メッセージ')
        // console.log(err);
        // setError('通信エラー');
        return previousPost;
      } finally {
      }
    }, ""
  );

  const [optimisticPost, updateOptimisticPost] = useOptimistic(updatedPost);

  const [updatedPut, submitActionPut, isPendingPut] = useActionState(
    async (previousPut, formData) => {
      const optimistic = {...previousPut,
        // room_uuidはonClickイベントでsetIdを渡していて、idに代入済
        list_uuid: listUuid,
        management_cd: '（更新中）',
        name: name + '（更新中）',
      };

      // 楽観的更新情報を表示
      updateOptimisticPut(optimistic);

      // 入力欄をクリアしてフォーカスを当てる 
      document.getElementById('name').value = "";
      document.getElementById('name')?.focus();
  
      try {
        if (cookies.jwtAccess) {
          // jwtがある場合、headers（認証情報）有り
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': `JWT ${cookies.jwtAccess}`,
          }

          // const response = await axios.put(`${apiHost}${basePath}2983ca11-3e1f-466a-b73b-3451d3695e4b/`, 
          const response = await axios.put(`${apiHost}${basePath}${listUuid}/`, 
            {
              // name: formData.get('name'),
              name: name,
            },
            {headers},
          )

          if (response.status === 200) {
            setEditDialogOpen(false);
            setTransactionFinishedDialogOpen(true);

            // 更新した名前を返す
            return response.data
          } else if (response.status === 401) {
            setError('ログインしてください');
          } else {
            setError('エラー');
          }
        } else {
          setError('認証エラー');
        }
      } catch (err) {
        // handleMessageBoxOpen('タイトル', 'メッセージ')
        // console.log(err);
        // setError('通信エラー');
        return previousPut;
      } finally {
      }
    }, ""
  );

  const [optimisticPut, updateOptimisticPut] = useOptimistic(updatedPut);


  // // サーバから値が返ってきたら、仮入力していた楽観的値を更新
  // useEffect(() => {
  //   fetchitems();
  // }, [optimisticGet, optimisticPost, optimisticPut, ]);


  const [clock, setClock] = useState("0000/00/00(　) 00:00:00");

  const time = () => {
    // 出力フォーマット
    const curTime = format(Date.now(), "yyyy/MM/dd  HH:mm:ss");
    setClock(curTime);

    // ログアウト時と同じ動作、MyPageへ遷移
    // (window.location.href = "/");
  };


  // サーバから値が返ってきたら、仮入力していた楽観的値を更新
  useEffect(() => {
    startTransition(async () => refreshLists());
    // refreshLists();
  // }, [optimisticGet, optimisticPost, optimisticPut, updatedGet, updatedPost, updatedPut]);
  }, [optimisticPost, optimisticPut, ]);
  
  
  useEffect(() => {
    const interval = setInterval(time, 200);
    // return () => {
    //   clearInterval(interval);
    // };
  });

  // 曜日によって色を変更する時計（平日：翠、土曜：青、日曜：赤）
  const clockInfo = () => {
    return (
      <>
        <div style={{ margin: "5px", fontWeight: 700, }}>
          {clock}
        </div>
      </>
    )
  }

  const itemsList = () => {
    return (
      <>
        {clockInfo()}
        <TableContainer>
          <Table style={{ background: 'linear-gradient(180deg, #9dbcfa, #68e3e7)', }}>
            <TableHead>
              <TableRow>
                <TableCell>No.</TableCell>
                <TableCell>更新日時</TableCell>
                <TableCell>uuid</TableCell>
                <TableCell>部屋名</TableCell>
                <TableCell>URL</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(lists)
                ? lists.map((list, index) => {
                  if (index < lists.length) {
                  return (
                    <TableRow key={list.uuid}>
                      <TableCell>{index + 1}</TableCell>
                      {/* 子テーブル（Roulette）にデータがあれば、そこのcreated_atの最大値を"yyyy/MM/dd HH:mm:ss"形式で表示、なければ "-"と表示 */}
                      <TableCell>{list.updated ? format(list.updated, "yyyy/MM/dd HH:mm:ss") : '-'}</TableCell>
                      <TableCell>{list.uuid}</TableCell>
                      <TableCell>
                        {/* データを更新する場合は、ボタンで子画面を開く */}
                        <form action={refreshListLists}>
                          {/* onClickイベントでidを更新して子画面の枠を表示 */}
                          {/* 子画面に表示する値の取得はsubmitActionGetで実行 */}
                          <AppButton type="submit" style={{ margin: "5px", fontSize: 20}} onClick={() => {setListUuid(list.uuid); setName('Loading...'); setEditDialogOpen(true)}}>
                            {list.name}
                          </AppButton>
                        </form>
                      </TableCell>
                      <TableCell>{list.url}</TableCell>
                    </TableRow>
                  )
                }
              })
                : null
              }
            </TableBody>
          </Table>
        </TableContainer>
      </>
    )
  }

  // ----------------------------------------------------------------------------------------------------
  return (
    <>
      <div className="container">
        <form action={submitActionPost}>
          <input style={{ margin: "5px", fontSize: 30, }} type="text" id="name" name="name" placeholder="部屋名を入力" />

          {/* ボタン押下の処理中かそうでないかにより、表示内容を変更 */}
          <AppButton type="submit" style={{ margin: "5px", fontSize: 20}} disabled={isPendingPost}>
            {!isPendingPost && <>部屋を作成</>}
            {isPendingPost && <>処理中...</>}
          </AppButton>

          {/* 処理中の場合、表示 */}
          {isPendingPost && <>
            <CircularProgress variant="indeterminate"
              disableShrink
              enableTrackSlot
              sx={(theme) => ({
                color: '#e42e16',
                animationDuration: '1000ms',
                ...theme.applyStyles('dark', {
                  color: '#308fe8',
                }),
              })}
              size={40}
              thickness={4}
            />
          </>}
        </form>
      </div>

      {/* loadingかどうかを視覚的に表示 */}
      {!isPendingLists && <><LinearProgress variant="determinate" value={"100"} /></>}
      {isPendingLists && <><LinearProgress /></>}

      <div style={{ background: 'linear-gradient(180deg, #000000, #000000)', border: '1px solid #cccccc', color: '#cccccc', }}>
        {itemsList()}
      </div>

      <div className="bd-callout bd-callout-limegreen" style={{ margin: "5px" }}>
        【自動更新情報】
        <Box>
          <Grid container spacing={2}>
            <Grid size={3}>
              <Item elevation={elevation}>ip:{ip ? ip : "xxx.xxx.xxx.xxx"}</Item>
            </Grid>
            <Grid size={3}>
              <Item elevation={elevation}>応答時間:{responseTime}ms</Item>
            </Grid>
            <Grid size={3}>
              {/* <Item elevation={elevation}>nextAccessIntervalTime:{Math.round(intervalAccessTime / 100) / 10}s（{intervalAccessTime}ms）</Item> */}
              <Item elevation={elevation}>インターバル:{Math.round(intervalAccessTime / 100) / 10}秒</Item>
            </Grid>
            <Grid size={3}>
              <Item elevation={elevation}>
                ユーザ名:{cookies.accessTokenUsername ? cookies.accessTokenUsername : "guest"}
                ({cookies.accessTokenUserId ? cookies.accessTokenUserId : "-"})
              </Item>
            </Grid>
            <Grid size={6}>
              <Item elevation={elevation}>前回リクエスト時刻:{lastRequestDateTime}</Item>
            </Grid>
            <Grid size={6}>
              <Item elevation={elevation}>前回レスポンス時刻:{lastResponseDateTime}</Item>
            </Grid>
          </Grid>
        </Box>
      </div>


      {/* 以下、ダイアログ---------------------------------------------------------------------------------------------------- */}
      <Dialog open={editDialogOpen}>
        <DialogTitle sx={{ m: 0, p: 2 }} id="edit-dialog-title">
          【編集】
          {(!isPendingListLists && !isPendingPut) && <><LinearProgress variant="determinate" value={"100"} /></>}
          {(isPendingListLists || isPendingPut) && <><LinearProgress /></>}
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText style={{display: 'flex', alignItems: 'flex-start', }}>
            <form action={submitActionPut}>
              {/* updatedGet.name:{updatedGet.name} */}
              <p>listUuid:{listUuid}</p>
              <input style={{ margin: "5px", fontSize: 30, }} type="text" id="name" name="name" placeholder="部屋名を入力" value={name} onChange={(e) => setName(e.target.value)} />
              {/* <input style={{ margin: "5px", fontSize: 30, }} type="text" id="management_cd" name="management_cd" value={updatedGet.management_cd} onChange={(e) => setManagementCd(e.target.value)} /> */}
              <AppButton type="submit" disabled={(isPendingListLists || isPendingPut)} style={{ margin: "5px", fontSize: 20, }}>
                {(!isPendingListLists && !isPendingPut) && <>更新</>}
                {isPendingListLists && <>読込中</>}
                {isPendingPut && <>更新中</>}
              </AppButton>
              <AppButton disabled={isPendingPut} onClick={handleEditDialogClose} style={{ margin: "5px", fontSize: 20, }}>キャンセル</AppButton>
            </form>
          </DialogContentText>

          <TableContainer>
            <Table style={{ background: 'linear-gradient(180deg, #9dbcfa, #68e3e7)', }}>
              <TableHead>
                <TableRow>
                  <TableCell>id</TableCell>
                  <TableCell>list_uuid</TableCell>
                  <TableCell>作成日時</TableCell>
                  <TableCell>名前</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(listlists)
                  ? listlists.map((listlist, index) => {
                    if (index < listlists.length) {
                    return (
                      <TableRow key={listlist.id}>
                        <TableCell>id:{listlist.id}</TableCell>
                        <TableCell>list_uuid_id:{listlist.list_uuid_id}</TableCell>
                        <TableCell>{listlist.created_at ? format(listlist.created_at, "yyyy/MM/dd HH:mm:ss") : '-'}</TableCell>
                        <TableCell>{listlist.name}</TableCell>
                        {/* <TableCell>
                          <form action={refreshListLists}>
                            <AppButton type="submit" style={{ margin: "5px", fontSize: 20}} onClick={() => {setListUuid(listlist.uuid); setName('Loading...'); setEditDialogOpen(true)}}>
                              {listlist.name}
                            </AppButton>
                          </form>
                        </TableCell> */}
                      </TableRow>
                    )
                  }
                })
                  : null
                }
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>

      <Dialog open={nowLoadingOpen}>
        <DialogTitle sx={{ m: 0, p: 2 }} id="nowLoading">
          【Loading】
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            {CircularProgress}
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog open={messageBoxOpen} onClose={handleMessageBoxClose}>
        <DialogTitle sx={{ m: 0, p: 2 }} id="messageBox-dialog-title">
          【{messageBoxTitle}】
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            {messageBoxMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <AppButton onClick={handleMessageBoxClose} autoFocus>OK</AppButton>
        </DialogActions>
      </Dialog>



      <Dialog open={transactionFinishedDialogOpen}>
        <DialogTitle sx={{ m: 0, p: 2 }} id="transactionFinishedDialog">
          【処理完了】
          {(!isPendingListLists && !isPendingPut) && <><LinearProgress variant="determinate" value={"100"} /></>}
        </DialogTitle>
        <DialogContent dividers>
          roomUuid:{optimisticPost.uuid}{optimisticPut.uuid}
          <DialogContentText id="transactionFinishedDialog-description" style={{ margin: "5px", fontSize: 20, }}>
          {optimisticPost.name}{optimisticPut.name}
          </DialogContentText>
          <AppButton id='transactionFinishedDialog' style={{ margin: "5px", fontSize: 20, }} onClick={handleTransactionFinishedDialogClose}>OK</AppButton>
        </DialogContent>
      </Dialog>
    </>
  );
};
export default List